import { WeightedOption, SurveyOptionType, RegionDTO } from '.';

export type SurveyListState = {
  loaded: boolean;
  loading: boolean;
  surveys: Survey[];
};

export type Survey = {
  id: string;
  takeGUID: string;
  shareResultsGUID: string;
  name: string;
  shareable: boolean;
  hideContactsOnShare: boolean;
  description: string;
  emailSubject: string;
  emailBody: string;
  createdOn: string;
  createdBy: string;
  sentCount: number;
  viewCount: number;
  region: RegionDTO;
  completedCount: number;
  /** Recipients on the survey, whether or not anything has been sent to them. */
  recipientCount: number;
  participationNetworkQuestion: string;
  details: {
    introduction: string;
    participation: string;
    benefits: string;
    confidentiality: string;
    questions: string;
  };
  questions: {
    network: {
      text: string;
      networkType: NetworkType;
      maximumEntries: number;
    };
    relationships: {
      text: string;
      options: WeightedOption[];
    };
    interactions: {
      text: string;
      options: WeightedOption[];
    };
  };
  organizationTypeList: SurveyOptionType[];
  nodeColors: SurveyOptionType[];
  participationNetworkTypeList: SurveyOptionType[];
};

export enum NetworkType {
  OrganizationOnly = 1,
  ContactAndOrganization = 2
}

/** Survey-level choices for a duplicate; everything else is always copied as-is. */
export type DuplicateSurveyRequest = {
  /** Idempotency key: reuse across retries of one duplicate, generate a new one for a new copy. */
  requestId: string;
  name?: string;
  regionId?: string;
  copyRecipients: boolean;
  shareable: boolean;
  hideContactsOnShare: boolean;
};

/** The 201 body: the copy, wrapped so an incomplete recipient list can be reported with it. */
export type DuplicateSurveyResponse = {
  survey: Survey;
  recipientsRequested: number;
  recipientsCopied: number;
  recipientsComplete: boolean;
};
